module.exports = __webpack_public_path__ + "img/carret_left_user_primary.129ec1f1.svg";